import React from "react";
import { Space } from "antd";
import { AxInputNumber, AxDivider, AxButton } from "@dynata/axiom3";

class InputNumber extends React.Component {
  render() {
    return (
      <div className="section" id="inputnumber">
        <h3>Input Number</h3>
        <p>Single line input element for numeric value.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxInputNumber size="large" min={1} max={100000} defaultValue={3} />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/input-number/#API"
                >
                  https://ant.design/components/input-number/#API
                </AxButton>
              </p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Default size is medium</td>
                  <td>large | medium | small</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>min</td>
                  <td>Minimum value</td>
                  <td>number</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>max</td>
                  <td>Maximum value</td>
                  <td>number</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>defaultValue</td>
                  <td>Default value</td>
                  <td>number</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>prefix</td>
                  <td>Display prefix icon or text</td>
                  <td>ReactNode</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>suffix</td>
                  <td>Display suffix icon or text</td>
                  <td>ReactNode</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td></td>
                  <td>boolean</td>
                  <td></td>
                </tr>
                <tr>
                  <td>addonAfter</td>
                  <td>
                    The label text displayed after (on the right side of) the
                    input field
                  </td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>addonBefore</td>
                  <td>
                    The label text displayed before (on the left side of) the
                    input field
                  </td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>autoFocus</td>
                  <td>If get focus when component mounted</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>bordered</td>
                  <td>Whether has border style</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td>4.12.0</td>
                </tr>
                <tr>
                  <td>controls</td>
                  <td>
                    Whether to show <code>+-</code> controls, or set custom
                    arrows icon
                  </td>
                  <td>boolean</td>
                  <td>-</td>
                  <td>4.19.0</td>
                </tr>
                <tr>
                  <td>decimalSeparator</td>
                  <td>Decimal separator</td>
                  <td>string</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>defaultValue</td>
                  <td>The initial value</td>
                  <td>number</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>If disable the input</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>formatter</td>
                  <td>Specifies the format of the value presented</td>
                  <td>
                    function(value: number | string, info:{" "}
                    <pre>
                      {"{ userTyping: boolean, input: string }): string"}
                    </pre>
                  </td>
                  <td>-</td>
                  <td>info: 4.17.0</td>
                </tr>
                <tr>
                  <td>keyboard</td>
                  <td>If enable keyboard behavior</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td>4.12.0</td>
                </tr>
                <tr>
                  <td>max</td>
                  <td>The max value</td>
                  <td>number</td>
                  <td>
                    <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER">
                      Number.MAX_SAFE_INTEGER
                    </a>
                  </td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>min</td>
                  <td>The min value</td>
                  <td>number</td>
                  <td>
                    <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MIN_SAFE_INTEGER">
                      Number.MIN_SAFE_INTEGER
                    </a>
                  </td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>parser</td>
                  <td>Specifies the value extracted from formatter</td>
                  <td>function(string): number</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>precision</td>
                  <td>
                    The precision of input value. Will use{" "}
                    <code>formatter</code> when config of <code>formatter</code>
                  </td>
                  <td>number</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>readOnly</td>
                  <td>If readonly the input</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>status</td>
                  <td>Set validation status</td>
                  <td>'error' | 'warning'</td>
                  <td>-</td>
                  <td>4.19.0</td>
                </tr>
                <tr>
                  <td>prefix</td>
                  <td>The prefix icon for the Input</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td>4.17.0</td>
                </tr>
                <tr>
                  <td>size</td>
                  <td>The height of input box</td>
                  <td>
                    <code>large</code> | <code>middle</code> |{" "}
                    <code>small</code>
                  </td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>step</td>
                  <td>
                    The number to which the current value is increased or
                    decreased. It can be an integer or decimal
                  </td>
                  <td>number | string</td>
                  <td>1</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>stringMode</td>
                  <td>
                    Set value as string to support high precision decimals. Will
                    return string value by <code>onChange</code>
                  </td>
                  <td>boolean</td>
                  <td>false</td>
                  <td>4.13.0</td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>The current value</td>
                  <td>number</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>The callback triggered when the value is changed</td>
                  <td>function(value: number | string | null)</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>onPressEnter</td>
                  <td>
                    The callback function that is triggered when Enter key is
                    pressed
                  </td>
                  <td>function(e)</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>onStep</td>
                  <td>
                    The callback function that is triggered when click up or
                    down buttons
                  </td>
                  <td>
                    (value: number, info:{" "}
                    <pre>{`{ offset: number, type: 'up' | 'down' }) = > void`}</pre>
                  </td>
                  <td>-</td>
                  <td>4.7.0</td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/input-number/#API"
                      >
                        {`<InputNumber />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxInputNumber size="large" min={1} max={100000} defaultValue={3} />
<AxInputNumber min={1} max={100000} defaultValue={3} />
<AxInputNumber size="small" min={1} max={100000} defaultValue={3} />
`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Large | Medium | Small
        </AxDivider>

        <Space size="large">
          <AxInputNumber size="large" min={1} max={100000} defaultValue={3} />
          <AxInputNumber min={1} max={100000} defaultValue={3} />
          <AxInputNumber size="small" min={1} max={100000} defaultValue={3} />
        </Space>
      </div>
    );
  }
}
export default InputNumber;
